import { onFCP, onCLS, onLCP, onTTFB, onINP, type Metric } from 'web-vitals';
import { events } from '@/services/analytics';
import { analytics } from '@/utils/analytics-factory';
import { getConnectionType } from '@/utils/functions/get-connection-type';

const logVital = (metric: Metric, page = '/') => {
	analytics.logEvent(events.WEB_VITALS, {
		metric: metric.name,
		value: metric.value,
		rating: metric.rating,
		connection: getConnectionType(),
		page
	});
};

export default function () {
	const trackWebVitals = (page: string) => {
		onCLS(metric => logVital(metric, page));
		onINP(metric => logVital(metric, page));
		onFCP(metric => logVital(metric, page));
		onLCP(metric => logVital(metric, page));
	};

	const trackTTFB = () => {
		onTTFB(metric => logVital(metric));
	};

	return {
		trackWebVitals,
		trackTTFB
	};
}
